
























































import { config } from "@/config";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
  public dialog = false;
  public drawer = null;
  public version = config.version;
  public items = [
    { icon: "home", text: "Home", name: "waiter_home" },
    { icon: "restaurant", text: "Manage Orders", name: "waiter_orders" }
  ];
}
